// Builds an embeddable scheduling URL from whatever the admin pasted:
// a Calendly link, a Google Calendar appointment-schedule link, or a full <iframe> embed snippet.
export function buildBookingEmbedUrl(raw, { name = "", email = "" } = {}) {
  let value = (raw || "").trim();
  const iframeSrc = value.match(/src=["']([^"']+)["']/i);
  if (iframeSrc) value = iframeSrc[1];
  if (!value) return "";

  let url;
  try {
    url = new URL(value);
  } catch {
    return value;
  }

  if (url.hostname.endsWith("calendly.com")) {
    url.searchParams.set("hide_gdpr_banner", "1");
    if (name) url.searchParams.set("name", name);
    if (email) url.searchParams.set("email", email);
  } else if (url.hostname === "calendar.google.com") {
    url.searchParams.set("gv", "true");
  }
  return url.toString();
}

export function bookingProviderLabel(raw) {
  const v = (raw || "").toLowerCase();
  if (v.includes("calendly.com")) return "Calendly";
  if (v.includes("google.com") || v.includes("calendar.app.google")) return "Google Calendar";
  return "Scheduling";
}
